<template>
  <div class="warpper">
    <table>
      <tr v-for="(item, i) in table" :key="i">
        <th :colspan="ele.col" :rowspan="ele.row" v-for="(ele) in item" :key="ele.title">
          <span class="text" :class="{'weight':ele.bold}" v-if="!ele.link">{{ele.title}}</span>
          <a :href="ele.link" v-else target="_blank">{{ele.link}}</a>
        </th>
      </tr>
    </table>
  </div>
</template>

<script>
import {table} from './configs/table'
export default {
  data() {
    return {
      table: Object.freeze(table)
    }
  }
}
</script>

<style lang="scss" scoped>
.warpper {
  width: 100%;
  height: 750px;
  overflow: scroll;
}
table, td, th {  
  border: 1px solid #ddd;
  text-align: left;
}

.text {
    min-width: 150px;
    display: inline-block;
    min-height: 30px;
    line-height: 30px;
}
// .weight {
//   font-weight: 700;
// }
</style>